import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const UnfillBedIcon = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
    >
      <path
        d="M3.99984 0.166687C3.55817 0.166687 3.1665 0.341687 2.82484 0.666687C2.48317 0.991687 2.33317 1.37502 2.33317 1.83335V4.33335C1.87484 4.33335 1.49984 4.49169 1.1665 4.82502C0.833171 5.15835 0.666504 5.55835 0.666504 6.00002V10.1667H1.77484L2.33317 11.8334H3.1665L3.72484 10.1667H14.2748L14.8332 11.8334H15.6665L16.2248 10.1667H17.3332V6.00002C17.3332 5.55835 17.1582 5.16669 16.8332 4.82502C16.4998 4.49169 16.1248 4.33335 15.6665 4.33335V1.83335C15.6665 1.37502 15.5082 1.00002 15.1748 0.666687C14.8415 0.333354 14.4415 0.166687 13.9998 0.166687M3.99984 1.83335H8.1665V4.33335H3.99984M9.83317 1.83335H13.9998V4.33335H9.83317V1.83335Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default UnfillBedIcon;
